import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export default function Dashboard() {
  const [stats, setStats] = useState({ users: 0, astrologers: 0, calls: 0, wallet: 0 });

  useEffect(() => {
    const fetchData = async () => {
      const usersSnap = await getDocs(collection(db, "users"));
      const astroSnap = await getDocs(collection(db, "astrologers"));
      const callsSnap = await getDocs(collection(db, "calls"));
      let totalWallet = 0;
      usersSnap.forEach((doc) => (totalWallet += doc.data().wallet || 0));
      setStats({
        users: usersSnap.size,
        astrologers: astroSnap.size,
        calls: callsSnap.size,
        wallet: totalWallet,
      });
    };
    fetchData();
  }, []);

  const chartData = [
    { name: "Users", value: stats.users },
    { name: "Astrologers", value: stats.astrologers },
    { name: "Calls", value: stats.calls },
  ];

  return (
    <div>
      <h1>📊 Dashboard</h1>
      <div className="card">
        <h3>Overview</h3>
        <p>Total Users: {stats.users}</p>
        <p>Total Astrologers: {stats.astrologers}</p>
        <p>Total Calls: {stats.calls}</p>
        <p>Total Wallet: ₹{stats.wallet}</p>
      </div>

      <div className="card">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#efc75e" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}